exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-calendar-view{padding-left:1rem;padding-right:1rem}.fts-calendar-view .date-selection{display:flex;align-items:center;margin-right:1rem}.fts-calendar-view .date-selection .date-label{margin-right:.575rem;font-size:.75rem;white-space:nowrap;color:var(--fts-text)}.fts-calendar-view .date-selection .date-label:not(:first-child){margin-left:.575rem}.fts-calendar-view .date-selection .date-select{width:200px}.fts-calendar-view .cv-event-trigger{text-decoration:none;color:#fff}.fts-calendar-view .cv-event-label{text-decoration:none;cursor:default}", ""]);

// exports
